import { inject, Injectable } from '@angular/core';
import { filter, map } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { libraryActions } from '../../library/actions/library.actions';
import { userActions } from '../actions/user.actions';

@Injectable()
export class User_LibraryBridge {
    private readonly actions = inject(Actions);

    getLibrary$ = createEffect(() => {
        return this.actions.pipe(
            ofType(userActions.getUserSuccess),
            map(({ user }) => user.pathId),
            filter((pathId) => pathId !== null),
            map((pathId) => libraryActions.getLibrary({ pathId })),
        );
    });
}
